import React from 'react';
import CompanyMenu from "../../layouts/dashboard/menu/companyMenu";
import CompanyManagerMenu from "../../layouts/dashboard/menu/companyManagerMenu";
import SupplierMenu from "../../layouts/dashboard/menu/SupplierMenu";
import InvestorsMenu from "../../layouts/dashboard/menu/InvestorsMenu";
import GeneralManagerMenu from "../../layouts/dashboard/menu/generalManagerMenu";
import Menu from "../../layouts/dashboard/menu";
import {useSelector} from "react-redux";
import { Link } from 'react-router-dom';

const LeftMenu = ({sub = false}) => {
    const { name : userType } = useSelector((state) => state.auth.user.roles[0]);
    // const userType = "company"
    let menu = null

    if (userType === "company") {
        menu = <CompanyMenu/>
    } else if (userType === "generalManager") {
        menu = <GeneralManagerMenu/>
    }  else if (userType === "companyManager") {
        menu = <CompanyManagerMenu/>
    } else if (userType === "investor") {
        menu = <InvestorsMenu/>
    } else if (userType === "supplier") {
        menu = <SupplierMenu/>
    }

    return (
        <nav
            className="js-nav-scroller navbar navbar-expand-lg navbar-sidebar navbar-vertical navbar-light bg-white border-end"
            data-hs-nav-scroller-options='{
                "type": "vertical",
                "target": ".navbar-nav .active",
                "offset": 80
               }'>
            <button type="button" className="navbar-toggler btn btn-white d-grid w-100" data-bs-toggle="collapse"
                    data-bs-target="#navbarVerticalNavMenu" aria-label="Toggle navigation" aria-expanded="false"
                    aria-controls="navbarVerticalNavMenu">
                        <span className="d-flex justify-content-between align-items-center">
                          <span className="h3 mb-0">Menu</span>

                          <span className="navbar-toggler-default">
                            <i className="bi-list"></i>
                          </span>

                          <span className="navbar-toggler-toggled">
                            <i className="bi-x"></i>
                          </span>
                        </span>
            </button>
            <div id="navbarVerticalNavMenu" className="collapse navbar-collapse">
                <div className="navbar-brand-wrapper border-end" style={{height: "auto"}}>
                    <div className="d-flex align-items-center mb-3">
                        <Link to={'/'} className="navbar-brand" >
                            <img className="navbar-brand-logo" height={50} src={`${sub ? '..' : '.'}/assets/img/logos/155x47/PNG/Groupe6.png`} alt="Logo"/>
                        </Link>
                    </div>
                </div>

                <div className="docs-navbar-sidebar-aside-body navbar-sidebar-aside-body">
                   <Menu></Menu>
                </div>
            </div>
        </nav>
    )
        ;
};

export default LeftMenu;